import { ActionType, PayloadErrorType } from 'types/reduxTypes';
import {
  GET_ACCESS_LEVEL,
  GET_ACCESS_LEVEL_FAILED,
  GET_ACCESS_LEVEL_SUCCESS,
  GET_AUTHORSHIP_TYPES,
  GET_AUTHORSHIP_TYPES_FAILED,
  GET_AUTHORSHIP_TYPES_SUCCESS,
  GET_CLS_ITEMS,
  GET_CONTENT_TYPES,
  GET_CONTENT_TYPES_FAILED,
  GET_CONTENT_TYPES_SUCCESS,
  GET_IDENTITY_SYSTEM,
  GET_IDENTITY_SYSTEM_FAILED,
  GET_IDENTITY_SYSTEM_SUCCESS,
  GET_LANGUAGES,
  GET_LANGUAGES_FAILED,
  GET_LANGUAGES_SUCCESS,
  GET_PUBLICATION_THEMATIC,
  GET_PUBLICATION_THEMATIC_FAILED,
  GET_PUBLICATION_THEMATIC_SUCCESS,
  GET_PUBLICATION_TYPE,
  GET_PUBLICATION_TYPE_FAILED,
  GET_PUBLICATION_TYPE_SUCCESS,
  GET_SCIENCE_AREA,
  GET_SCIENCE_AREA_FAILED,
  GET_SCIENCE_AREA_SUCCESS,
  GET_SCIENCE_FIELD,
  GET_SCIENCE_FIELD_FAILED,
  GET_SCIENCE_FIELD_SUCCESS,
  GET_SETTINGS_ACCESS_LEVELS,
  GET_SETTINGS_ACCESS_LEVELS_FAILED,
  GET_SETTINGS_ACCESS_LEVELS_SUCCESS,
  GET_UPLOAD_FILE_EXTENTIONS,
  GET_UPLOAD_FILE_EXTENTIONS_FAILED,
  GET_UPLOAD_FILE_EXTENTIONS_SUCCESS,
  GET_UPLOAD_FILE_MIME,
  GET_UPLOAD_FILE_MIME_FAILED,
  GET_UPLOAD_FILE_MIME_SUCCESS,
  GET_UPLOAD_ITEM_TYPES,
  GET_UPLOAD_ITEM_TYPES_FAILED,
  GET_UPLOAD_ITEM_TYPES_SUCCESS,
} from '../constants';
import { ClsItem } from 'types/clsType';

export type GetClsItemsPayload = {
  cls: number;
  lang?: number;
  page?: number;
  pageSize?: number;
  success: (payload: ClsItem[]) => ActionType<ClsItem[]>;
  failed: (payload: PayloadErrorType) => ActionType<PayloadErrorType>;
};

export type FindClsItemsPayload = GetClsItemsPayload & {
  term?: string;
  level?: number;
};

export function getClsItems(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_CLS_ITEMS,
  };
}

export function getSettingsAccessLevels(payload: unknown): ActionType<unknown> {
  return {
    payload,
    type: GET_SETTINGS_ACCESS_LEVELS,
  };
}

export function getSettingsAccessLevelsFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_SETTINGS_ACCESS_LEVELS_FAILED,
  };
}

export function getSettingsAccessLevelsSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_SETTINGS_ACCESS_LEVELS_SUCCESS,
  };
}

export function getAccessLevel(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_ACCESS_LEVEL,
  };
}

export function getAccessLevelFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_ACCESS_LEVEL_FAILED,
  };
}

export function getAccessLevelSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_ACCESS_LEVEL_SUCCESS,
  };
}

export function getUploadItemTypes(payload: { lang: number }): ActionType<{ lang: number }> {
  return {
    payload,
    type: GET_UPLOAD_ITEM_TYPES,
  };
}

export function getUploadItemTypesFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_UPLOAD_ITEM_TYPES_FAILED,
  };
}

export function getUploadItemTypesSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_UPLOAD_ITEM_TYPES_SUCCESS,
  };
}

export function getContentTypes(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_CONTENT_TYPES,
  };
}

export function getContentTypesFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_CONTENT_TYPES_FAILED,
  };
}

export function getContentTypesSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_CONTENT_TYPES_SUCCESS,
  };
}

export function getAuthorshipTypes(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_AUTHORSHIP_TYPES,
  };
}

export function getAuthorshipTypesFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_AUTHORSHIP_TYPES_FAILED,
  };
}

export function getAuthorshipTypesSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_AUTHORSHIP_TYPES_SUCCESS,
  };
}

export function getUploadFileExtentions(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_UPLOAD_FILE_EXTENTIONS,
  };
}

export function getUploadFileExtentionsFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_UPLOAD_FILE_EXTENTIONS_FAILED,
  };
}

export function getUploadFileExtentionsSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_UPLOAD_FILE_EXTENTIONS_SUCCESS,
  };
}

export function getUploadFileMime(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_UPLOAD_FILE_MIME,
  };
}

export function getUploadFileMimeFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_UPLOAD_FILE_MIME_FAILED,
  };
}

export function getUploadFileMimeSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_UPLOAD_FILE_MIME_SUCCESS,
  };
}

export function getScienceField(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_SCIENCE_FIELD,
  };
}

export function getScienceFieldFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_SCIENCE_FIELD_FAILED,
  };
}

export function getScienceFieldSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_SCIENCE_FIELD_SUCCESS,
  };
}

export function getScienceArea(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_SCIENCE_AREA,
  };
}

export function getScienceAreaFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_SCIENCE_AREA_FAILED,
  };
}

export function getScienceAreaSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_SCIENCE_AREA_SUCCESS,
  };
}

export function getLanguages(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_LANGUAGES,
  };
}

export function getLanguagesFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_LANGUAGES_FAILED,
  };
}

export function getLanguagesSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_LANGUAGES_SUCCESS,
  };
}

export function getIdentitySystem(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_IDENTITY_SYSTEM,
  };
}

export function getIdentitySystemFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_IDENTITY_SYSTEM_FAILED,
  };
}

export function getIdentitySystemSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_IDENTITY_SYSTEM_SUCCESS,
  };
}

export function getPublicationType(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_PUBLICATION_TYPE,
  };
}

export function getPublicationTypeFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_PUBLICATION_TYPE_FAILED,
  };
}

export function getPublicationTypeSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_PUBLICATION_TYPE_SUCCESS,
  };
}

export function getPublicationThematic(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_PUBLICATION_THEMATIC,
  };
}

export function getPublicationThematicFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_PUBLICATION_THEMATIC_FAILED,
  };
}

export function getPublicationThematicSuccess(payload: ClsItem[]): ActionType<ClsItem[]> {
  return {
    payload,
    type: GET_PUBLICATION_THEMATIC_SUCCESS,
  };
}
